// Bloomberg-style command line, 32px. 3-letter codes + fluent syntax.
// Tab = complete · ↑ = history · ⏎ = run · ⌘K = overlay.

import { useTranslation } from 'react-i18next';
import { WorldClocks } from './WorldClocks';

export function CommandLine() {
  const { t } = useTranslation();
  return (
    <div
      style={{
        height: 32,
        flexShrink: 0,
        borderTop: '1px solid var(--bd)',
        background: 'var(--bg-pane)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '0 12px',
          height: '100%',
          borderRight: '1px solid var(--bd)',
          color: 'var(--fg-3)',
          fontSize: 11,
        }}
      >
        <span style={{ color: 'var(--primary)' }}>›</span>
        <span style={{ color: 'var(--primary)', letterSpacing: 0.5 }}>
          {t('shell.commandBar.cmd')}
        </span>
      </div>
      <div
        style={{
          flex: 1,
          padding: '0 12px',
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          fontFamily: 'var(--mono)',
          fontSize: 12,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
      >
        {/* T13: the command line previously rendered a fabricated example
            query (DOD · NAICS 541512 · 8A · >30D) that read like the
            operator's active filter state. Until the command line is wired
            to real input + the query compiler, show a neutral placeholder
            prompt — never a fake specific query.
            T13-followup: wire to the command compiler (parse + run) so this
            reflects the operator's actual typed query. */}
        <span style={{ color: 'var(--fg-3)' }}>{t('shell.commandBar.placeholder')}</span>
        <span className="caret" />
        <span style={{ color: 'var(--fg-3)', marginLeft: 14, fontSize: 11 }}>
          {t('shell.commandBar.hint')}
        </span>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '0 12px',
          borderLeft: '1px solid var(--bd)',
          color: 'var(--fg-3)',
          fontSize: 11,
        }}
      >
        <WorldClocks />
        <span style={{ width: 1, height: 14, background: 'var(--bd)', flexShrink: 0 }} />
        <span className="kbd">⌘K</span>
        <span>{t('shell.commandBar.overlay')}</span>
      </div>
    </div>
  );
}
